import { render, staticRenderFns } from "./CadastrarOperacao.vue?vue&type=template&id=b8ab56b4&scoped=true&lang=pug"
import script from "./CadastrarOperacao.vue?vue&type=script&lang=js"
export * from "./CadastrarOperacao.vue?vue&type=script&lang=js"
import style0 from "./CadastrarOperacao.vue?vue&type=style&index=0&id=b8ab56b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ab56b4",
  null
  
)

export default component.exports